export default (store) => {
  store.registerModule('clarity', {
    namespaced: true,

    state: {
      registered: [],
    },

    getters: {
    },

    mutations: {
      setRegistered(state, payload) {
        state.registered.push(payload);
      },

      resetRegistered(state) {
        state.registered = [];
      },

      removeRegistered(state, payload) {
        state.registered = state.registered.filter((v) => v.event !== payload);
      },
    },

    actions: {
      consent() {
        window.clarity('consent');
      },

      async identify({ state, rootState: { auth }, commit }) {
        if (!window.clarity) {
          return;
        }

        // Consent is required before identifying
        if (!state.registered.includes('consent')) {
          this.dispatch('clarity/consent');
          commit('setRegistered', 'consent');
        }

        const visitorId = (this.$tracking.getVisitorId() || 0).toString();
        await window.clarity('identify', visitorId.toString());

        // Set paid status if user is logged in
        if (auth.user) {
          window.clarity('set', 'paid', auth.user.activeSubscription.toString());
        }
      },
    },
  });
};
